import StorageManager from './StorageManager'
import SessionStorageManager from './SessionStorageManager'
import { logger } from './logger'
import { mixtilesAxios } from '../utils/ApiUtils'
import { analytics } from './Analytics/Analytics'

const LOGIN_STATE_KEY = 'loginState'
export const ACTIVE_ORDERS_COUNT_KEY = 'activeOrdersCount'
export const IS_NEW_ACCOUNT_KEY = 'isNewAccount'
export const MISSING_EMAIL_ERROR = 'missingEmail'
export const LAST_USED_LOGIN_METHOD_KEY = 'lastUsedLoginMethod'
export const SHOW_LOGIN_SNACKBAR_KEY = 'showLoginSnackbar'
export const LOGGED_OUT_PARAM = 'logged_out'

export const LOGIN_METHODS = {
  EMAIL: 'email',
  GOOGLE: 'google-oauth2',
  APPLE: 'apple',
}

export const getLastUsedLoginMethod = () =>
  StorageManager.get(LAST_USED_LOGIN_METHOD_KEY)

export const setLastUsedLoginMethod = (method) =>
  StorageManager.set(LAST_USED_LOGIN_METHOD_KEY, method)

export const getLastUsedLoginMethodMap = () => {
  const lastUsed = getLastUsedLoginMethod()
  return {
    [LOGIN_METHODS.EMAIL]: lastUsed === LOGIN_METHODS.EMAIL,
    [LOGIN_METHODS.GOOGLE]: lastUsed === LOGIN_METHODS.GOOGLE,
    [LOGIN_METHODS.APPLE]: lastUsed === LOGIN_METHODS.APPLE,
  }
}

export const getAuthRequestConfig = (accessToken) =>
  accessToken ? { headers: { Authorization: `Bearer ${accessToken}` } } : {}

const getLoginSource = () => {
  const { url, options } = getLocationBeforeLogin()
  return options.source || `Other (${url.pathname})`
}

export const loginReport = async ({ token, email, isEmbeddedLogin }) => {
  try {
    const config = getAuthRequestConfig(token)
    const response = await mixtilesAxios.get('v1/auth/loginSuccess', config)
    const { analyticsInfo } = response && response.data
    if (analyticsInfo) {
      const { isNewUser, authMethod, previousOrdersCount, isAccountVerified } =
        analyticsInfo
      StorageManager.set(IS_NEW_ACCOUNT_KEY, isNewUser)
      const eventName = isNewUser ? 'User Created an Account' : 'User logged in'
      const source = getLoginSource()
      const eventData = {
        'Login Method': authMethod,
        'Number of Previous Orders': previousOrdersCount,
        Email: email,
        'Is Account Verified': isAccountVerified,
        Source: source,
        'Is Embedded Login': isEmbeddedLogin,
      }
      analytics.track(eventName, eventData)
      return isAccountVerified
    }
  } catch (e) {
    logger.error('failed to handle login success', e)
  }
  return true
}

// TODO: THIS SHOULDN'T BE HERE! orders have nothing to do with login need to destructure and re-organize
export const getOrdersForAccount = async (accessToken) => {
  const config = getAuthRequestConfig(accessToken)
  const response = await mixtilesAxios.get('v5/myOrders', config)
  const orders = response && response.data && response.data.orders
  const { activeOrders } = orders
  StorageManager.set(ACTIVE_ORDERS_COUNT_KEY, activeOrders.length)
  return orders
}

export const sendVerificationEmail = async (accessToken) => {
  const config = getAuthRequestConfig(accessToken)
  await mixtilesAxios.post('/v1/auth/resendVerificationEmail', {}, config)
}

export const saveStateBeforeLogin = ({ source, targetUrl = '' }) => {
  if (!source) {
    source = null
  }
  const currentState = {
    url: { pathname: window.location.pathname },
    options: { source },
    targetUrl,
  }
  SessionStorageManager.set(LOGIN_STATE_KEY, currentState)
}

export const saveQueryParamsBeforeLogin = (queryParams) => {
  const { url, options, targetUrl } = getLocationBeforeLogin()
  url.search = queryParams
  const currentState = {
    url,
    options,
    targetUrl,
  }
  SessionStorageManager.set(LOGIN_STATE_KEY, currentState)
}

export const getLocationBeforeLogin = () => {
  const defaultValue = {
    url: { pathname: '/', query: {} },
    options: {},
    targetUrl: null,
  }
  return SessionStorageManager.getWithDefaultValue(
    LOGIN_STATE_KEY,
    defaultValue
  )
}

export const redirectAfterLogin = ({
  navigate,
  isVerified = false,
  loginError = null,
}) => {
  const { url, options, targetUrl } = getLocationBeforeLogin()
  if (targetUrl) {
    const [pathname, search] = targetUrl.split('?')
    url.pathname = pathname
    url.search = search
  }

  if (loginError) {
    url.query = { ...url.query, loginError }
  } else if (!isVerified) {
    url.query = { ...url.query, verifyAccount: true }
  }

  navigate(url, { state: options, replace: true })
}
